<template>
  <div class="relative">
    <swiper class="parallax-slider" id="parallax-slider" ref="parallax-slider">
      <swiper-slide v-for="(data, index) in datas" :key="index">
        <div class="mr-6">
          <card-explore-movie :data="data" />
        </div>
      </swiper-slide>
    </swiper>

    <!-- 
    Installed swiper6 here

    Incase, you're wondering why i wrote my own code, some part of the package wasn't blending to my suit. 

    Graciers
    -->

    <!-- Button -->
    <div class="buttons">
      <button class="prev" @click="scrollLeft">
        <i class="fas fa-chevron-left fa-2x"></i>
      </button>
      <button class="next" @click="scrollRight">
        <i class="fas fa-chevron-right fa-2x"></i>
      </button>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Navigation, Parallax } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
// import css
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import CardExploreMovie from "./Card/CardExploreMovie.vue";
// Use core
SwiperCore.use([Navigation, Parallax]);

export default {
  name: "paper-swiper",
  props: {
    datas: Array
  },
  components: {
    Swiper,
    SwiperSlide,
    CardExploreMovie
  },
  data() {
    return {
      parallaxSwiperWidth: 0
    };
  },
  methods: {
    scrollLeft() {
      let parallaxSlider = document.querySelector("#parallax-slider");
      parallaxSlider.scrollLeft = parallaxSlider.scrollLeft - 200;
    },
    scrollRight() {
      let parallaxSlider = document.querySelector("#parallax-slider");
      parallaxSlider.scrollLeft = parallaxSlider.scrollLeft + 200;
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: inherit;
  overflow-x: scroll;
  margin: 0;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 0;
  }
  .swiper-slide {
    width: fit-content !important;
  }

  .bottom-0 {
    bottom: 0;
  }
}

.buttons {
  button {
    border: 2px solid #fff;
    background: transparent;
    color: rgb(52, 209, 227);
    cursor: pointer;
    padding: 9px 15px;
    border-radius: 50%;
    outline: none;
    z-index: 15;

    &:hover {
      background-color: rgba(22, 27, 40, 0.3);
    }
  }

  button.next,
  button.prev {
    position: absolute;
    top: 40%;
  }

  button.prev {
    left: 15px;
  }
  button.next {
    right: 15px;
  }
}
</style>
